/**
 * Formats a numeric string to 2 decimal places.
 */
export const formatPrice = (value: string | null | undefined): string => {
  if (!value) return ''
  return Number.parseFloat(value).toFixed(2)
}

/**
 * Adds thousands separators (commas) to a numeric string.
 */
export const addThousandsSeparator = (value: string): string => {
  const parts = value.split('.', 2)
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

/**
 * Replaces ASCII hyphen-minus with a proper minus sign (−).
 */
export const fixNegativeSign = (value: string): string => {
  return value.replace(/-/g, '\u2212')
}

/**
 * Formats a price value with thousands separators and 2 decimal places.
 */
export const formatDisplayPrice = (value: string): string => {
  return addThousandsSeparator(formatPrice(value))
}

/**
 * Formats a price change string with proper sign and separators.
 */
export const formatPriceChange = (prcChg: string): string => {
  const numValue = Number.parseFloat(prcChg)
  const formatted = formatDisplayPrice(prcChg)

  if (numValue > 0) return `+${formatted}`
  if (numValue < 0) return fixNegativeSign(formatted)
  return formatted
}
